import { clamp } from './mapPanBounds'

// The popup is 180px wide with a 16px arrow in styles.module.scss.
const CALLOUT_HALF_WIDTH = 90
const ARROW_HALF_WIDTH = 8
const ARROW_EDGE_GAP = 24
const MOBILE_CALLOUT_MIN_LEFT = 68

export const getCalloutHorizontalPosition = (
  anchorX: number,
  frameWidth: number,
  detailsReserve: number,
  isMobile: boolean
) => {
  const minX = CALLOUT_HALF_WIDTH + (isMobile ? MOBILE_CALLOUT_MIN_LEFT : 16)
  const maxX = Math.max(minX, frameWidth - detailsReserve - CALLOUT_HALF_WIDTH)
  const x = clamp(anchorX, minX, maxX)
  const maxArrowOffset = CALLOUT_HALF_WIDTH - ARROW_HALF_WIDTH - ARROW_EDGE_GAP

  return {
    x,
    arrowOffset: clamp(anchorX - x, -maxArrowOffset, maxArrowOffset),
  }
}
